import { HistoryItem } from '../Timeline/types';
import { IconType } from '../Icon/Icon';
import { WaterServiceComment } from './WaterServiceDetail';

export const convertWaterServiceComment = ({
  id,
  created,
  profile,
  comment,
}: WaterServiceComment): HistoryItem<'COMMENT'> => {
  const title: string | undefined = undefined;
  const icon: IconType = 'chat-dots';
  const iconColor: string | undefined = undefined;

  return {
    id,
    created: created ?? 0,
    profile,
    type: 'COMMENT',
    comment: comment || undefined,
    title,
    icon,
    iconColor,
  };
};
